
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"oeamtc-icon__sunrise","width":"16","height":"16","fill":"#fff"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 10a.5.5 0 00.5.5h2a.5.5 0 000-1h-2a.5.5 0 00-.5.5zm-.46-2.83L13 5.76a.5.5 0 00-.71-.71l-1.46 1.41a.5.5 0 10.71.71zm-4.6-2.9l.56-.56V5.5a.5.5 0 001 0V3.71l.56.56a.5.5 0 00.71-.71L8.35 2.15a.48.48 0 00-.7 0L6.23 3.56a.5.5 0 00.71.71zm-2.48 2.9a.5.5 0 00.71-.71L3.76 5.05a.5.5 0 10-.71.71zM15 12h-4.78a3 3 0 10-4.44 0H1a.5.5 0 000 1h14a.5.5 0 000-1zm-7 0a2 2 0 112-2 2 2 0 01-2 2zm-6.5-1.5h2a.5.5 0 000-1h-2a.5.5 0 000 1z"}})])
          )
        }
      }
    